// @ts-nocheck
'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useRef } from 'react';

const DoubleRowCarousel = ({ data }) => {
  const halfIndex = Math.ceil(data.length / 2);
  const topCarouselData = data.slice(0, halfIndex);
  const bottomCarouselData = data.slice(halfIndex);

  return (
    <div className="disperse space-y-5">
      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        speed={45000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: false,
        }}
        modules={[Autoplay]}
        className="top-slider"
      >
        {topCarouselData.map((item, i) => (
          <SwiperSlide
            id="testimonial-card-I"
            className="manrope-regular"
            key={i}
          >
            <div className="header">
              <div>
                <img
                  src={
                    'https://ui-avatars.com/api/?name=' +
                    encodeURIComponent(item.name)
                  }
                />
              </div>
              <div className="info">
                <h5>{item.name}</h5>
                <span>{item.role}</span>
              </div>
            </div>
            <div className="testimonial-body">{item.message}</div>
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        speed={45000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        }}
        modules={[Autoplay]}
        className="bottom-slider"
      >
        {bottomCarouselData.map((item, i) => (
          <SwiperSlide
            id="testimonial-card-I"
            className="manrope-regular"
            key={i}
          >
            <div className="header">
              <div>
                <img
                  src={
                    'https://ui-avatars.com/api/?name=' +
                    encodeURIComponent(item.name)
                  }
                />
              </div>
              <div className="info">
                <h5>{item.name}</h5>
                <span>{item.role}</span>
              </div>
            </div>
            <div className="testimonial-body">{item.message}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DoubleRowCarousel;
